<template>
  <div style="border: 0px solid black; width:100%;">
    <div class="welcome" style="border: 0px solid red;">
      <row
        style="border:0px solid green;position: inherit;display:contents;width:100%;"
      >
        <div class="box box-primary">
          <div class="box-header with-border" style="width:100%">
            <div
              style="text-align:center; font-size: 17px;text-align:left;color:#5b6c7f;margin-bottom:20px;"
            >
              <b>{{ $t('newsManagement.residentNews.list') }}</b>
              <lte-button
                @click="callback()"
                style="float:right;background-color:white !important; margin-right: 50px"
                type="btn btn-default"
                right_icon="fa fa-plus"
                >{{ $t("user.createnew") }}</lte-button>
            </div>
          </div>
          <div class="box-body">
            <b-table
              :per-page="perPage"
              :current-page="currentPage"
              striped
              hover
              :fields="gridColumns"
              :items="residentNewsList"
            >
              <template #head()="data">
                {{ $t(data.label) }}
              </template>
              <template #cell(file)="data">
                <a target="_blank" :href="data.item.file">{{ data.item.documentName }}</a>
              </template>
              <template #cell(title)="row">
                {{ spliceString(row.item.title, 50) }}
              </template>
              <template #cell(content)="row">
                {{ spliceString(row.item.content, 50) }}
              </template>
              <template #cell(actions)="data">
                <div class="btn-group">
                  <button
                    class="btn btn-primary"
                    style="margin-left: 6px"
                    @click="onEditResidentNews(data.item.id)"
                  >
                    <i class="glyphicon glyphicon-edit"></i>
                  </button>
                  <button
                    class="btn btn-danger"
                    style="margin-left: 6px"
                    @click="onDeleteResidentNews(data.item.id)"
                  >
                    <i class="glyphicon glyphicon-trash"></i>
                  </button>
                </div>
              </template>
            </b-table>
          </div>
        </div>
        <div class="box-footer clearfix" style="display:contents;">
          <paginator :item="paginatorItem" @onpaginate="onPagination" />
        </div>
      </row>
      <lte-core-alert
        v-for="snackbar in GET_SNACK_BAR"
        :key="snackbar.id"
        :item="snackbar"
      ></lte-core-alert>
      <loading
        :active.sync="isLoading"
        :can-cancel="false"
        color="#1E90FF"
      ></loading>
    </div>
    <div class="modal fade" id="modal-confirm-delete-banner">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-body">
            <h4>
              {{ $t('newsManagement.residentNews.confirmDeleteTitle') }}
            </h4>
          </div>
          <div class="modal-footer">
            <button
              @click="onConfirmDeleteResidentNews()"
              type="button"
              class="btn btn-primary btn-sm pull-right"
            >
              {{ $t('common.delete_modal.btnYes') }}
            </button>
            <button
              type="button"
              class="btn btn-warning btn-sm pull-left"
              data-dismiss="modal"
            >
              {{ $t("common.back") }}
            </button>
          </div>
        </div>
        <!-- /.modal-content -->
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
import Paginator from "@/components/Paginator.vue";
import LTEButton from "@/components/LTEButton.vue";
import LTECoreAlert from "@/components/LTESnackBar.vue";
import utils from "@/lib/utils";
import Loading from "vue-loading-overlay";
export default {
  name: "UserGuestList",
  data() {
    return {
      residentNewsList: [],
      currentPage: 1,
      totalRows: 1,
      entryId: 0,
      user_guest_deleted_id: null,
      user_guest_last_name: "",
      perPage: 50,
      isLoading: false,
      user_guest_name: "",
      isModalVisible: false,
      gridColumns: [
        {
          key: "user_guest.nonumber",
          label: "user_guest.nonumber",
          class: "text-center",
          tdClass: "stt"
        },
        { 
          key: "title",
          label: "banner.title",
          class: "text-center",
          tdClass: "stt"
        },
        { 
          key: "content",
          label: "newsManagement.residentNews.content",
          class: "text-center",
          tdClass: "stt"
        },
        { 
          key: "userCreated",
          label: "newsManagement.residentNews.userUpload",
          class: "text-center",
          tdClass: "stt"
        },
        { 
          key: "file",
          label: "newsManagement.residentNews.attachmentsFile",
          class: "text-center",
          tdClass: "stt"
        },
        { 
          key: "dateCreated",
          label: "banner.dateCreated",
          class: "text-center",
          tdClass: "stt"
        },
        { 
          key: "actions",
          label: "mail_form.action",
          class: "text-center",
          tdClass: "stt"
        }
      ],
      customColumns: {
        "user.is_active": {
          true: "btn-label label-success glyphicon glyphicon-ok",
          false: "btn-label label-danger glyphicon glyphicon-remove"
        }
      },
      actions: ["common.modify", "common.delete"],
      paginatorItem: {
        commit_function: "GET_RESIDENTS_NEWS_LIST"
      },
      hdBackground:
        "background-color: #4b646f;color:white;border:1px solid white;",
      residentNewsIdSelected: null
    };
  },
  computed: {
    ...mapGetters([
      "GET_SNACK_BAR",
      "PAGINATOR",
      "PAGINATION",
      "GET_ACCOUNT_DATA",
      "GET_RESIDENTS_NEWS_LIST_DATA"
    ])
  },
  watch: {
    GET_RESIDENTS_NEWS_LIST_DATA: function () {
      let data = this.GET_RESIDENTS_NEWS_LIST_DATA;
      this.residentNewsList = []
      for (let i = 0, size = data.length; i < size; i++) {
        let nonumber =
          i + 1 + (this.PAGINATION.page - 1) * this.PAGINATION.size;
        let object = {
          "id": data[i].id,
          "user_guest.nonumber": nonumber,
          "title": data[i].title,
          "file": data[i].document_url,
          "content": data[i].content,
          "userCreated": data[i].user_created.last_name + ' ' + data[i].user_created.first_name,
          "documentName": data[i].document_name,
          'dateCreated': this.formatDate(data[i].date_created)
        };
        this.residentNewsList.push(object);
      }
    }
  },
  methods: {
    ...mapActions([
      "SUCCESS_TOAST",
      "ON_SHOW_TOAST",
      "ERROR_TOAST",
      "GET_RESIDENTS_NEWS_LIST",
      "DELETE_RESIDENT_NEWS"
    ]),
    spliceString: function(strText, len) {
      return utils.spliceString(strText, len);
    },
    formatDate(date) {
      return utils.formatSqlDate(date, null, "DD/MM/YYYY");
    },
    /**
     * Edit banner
     */
    onEditResidentNews: function (id) {
      this.$router.push({
        name: "ResidentsUpdate",
        params: {
          id: id
        }
      });
    },
    /**
     * Confirm delete banner
     */
    onConfirmDeleteResidentNews: function () {
      this.DELETE_RESIDENT_NEWS({
        id: this.residentNewsIdSelected
      }).then(
        function () {
          this.SUCCESS_TOAST();
          $("#modal-confirm-delete-banner").modal("hide");
          this.getResidentsNewsList(1)
        }.bind(this)
      ).catch(
        function () {
          this.ERROR_TOAST();
        }.bind(this)
      )
    },
    /**
     * Edit banner
     */
    onDeleteResidentNews: function (id) {
      this.residentNewsIdSelected = id
      $("#modal-confirm-delete-banner").modal("show");
    },
    callback: function() {
      this.$router.push({
        name: "ResidentsAdd",
        params: {
          id: 0
        }
      });
    },
    onPagination: function(data) {
      this.getResidentsNewsList(data.params.page)
    },
    /**
     * Get banner list
     */
    getResidentsNewsList: function (page) {
      const data = {
        params: {
          page: page
        }
      };
      this.isLoading = true
      this.GET_RESIDENTS_NEWS_LIST(data).then(
        function () {
          this.isLoading = false
        }.bind(this)
      ).catch(
        function () {
          this.isLoading = false
        }.bind(this)
      )
    }
  },
  mounted() {
    this.getResidentsNewsList(1)
  },
  components: {
    "lte-button": LTEButton,
    "lte-core-alert": LTECoreAlert,
    paginator: Paginator,
    loading: Loading
  }
};
</script>
<style scoped>
.modal {
  text-align: center;
}

@media screen and (min-width: 768px) { 
  .modal:before {
    display: inline-block;
    vertical-align: middle;
    content: " ";
    height: 100%;
  }
}

.modal-dialog {
  display: inline-block;
  text-align: left;
  vertical-align: middle;
}
</style>



// WEBPACK FOOTER //
// src/views/News/ResidentsList.vue